import { TZDate } from "@date-fns/tz"
import { getHours, isWeekend } from "date-fns"
import { CUSTOMER_SERVICE_OPENING_HOURS } from "../constants/openingHours"

/**
 * Whether the customer service can be reached at the given date, i.e. Monday
 * to Friday between the opening and closing hours, in the customer service timezone
 * (not the visitor's).
 */
export function isCustomerServiceAvailable(date: Date = new Date()): boolean {
    const { timeZone, startHour, endHour } = CUSTOMER_SERVICE_OPENING_HOURS

    const customerServiceDate = new TZDate(date, timeZone)
    const customerServiceHours = getHours(customerServiceDate)

    return (
        !isWeekend(customerServiceDate) &&
        customerServiceHours >= startHour &&
        customerServiceHours < endHour
    )
}
